import { useEffect, useState } from "react";
import { TeamMemberCredentials } from "../pages/my-team/team-members-information/team-member-credentials";
import { Button } from "./button";

type CredentialsProps = {
  firstName?: string;
  lastName?: string;
  username: string;
  password: string;
  className?: string;
  onBack: () => void;
  ownCredentials?: boolean;
};

export const NewCredentialsDisplay = ({
  firstName,
  lastName,
  username,
  password,
  className,
  onBack,
  ownCredentials,
}: CredentialsProps) => {
  const [isBlocking, setIsBlocking] = useState(true);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isBlocking) {
        event.preventDefault();
      }
    };

    const handlePopState = (event: PopStateEvent) => {
      if (isBlocking) {
        event.preventDefault();
        const confirmed = window.confirm(
          "¿Está seguro de que desea salir? Asegúrese de haber copiado las credenciales de inicio de sesión del usuario."
        );
        if (confirmed) {
          setIsBlocking(false);
          window.history.go(-1);
        } else {
          window.history.pushState(null, "", window.location.pathname);
        }
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isBlocking]);

  const handleBack = () => {
    if (
      window.confirm(
        "¿Está seguro de que desea salir? Asegúrese de haber copiado las credenciales de inicio de sesión del usuario."
      )
    ) {
      setIsBlocking(false);
      onBack();
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <TeamMemberCredentials
        firstName={firstName}
        lastName={lastName}
        username={username}
        password={password}
        className={className}
        ownCredentials={ownCredentials}
      />
      <Button
        type="button"
        text="Volver atrás"
        variant="back"
        onClick={handleBack}
      />
    </div>
  );
};
